import HeroBg from "public/physicaLlabs/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Build, test, and validate IT solutions today",
    link: "contact-us",
  },
  title: "Test & Develop IT Solutions in Cloud-Based Physical Labs",
  desc: "Deploy, test, and refine IT solutions in real hardware environments—accessible anytime through the cloud.",
  image: HeroBg,
};
